import { render, staticRenderFns } from "./DashboardPanel.vue?vue&type=template&id=211b32be&scoped=true&"
import script from "./DashboardPanel.vue?vue&type=script&lang=js&"
export * from "./DashboardPanel.vue?vue&type=script&lang=js&"
import style1 from "./DashboardPanel.vue?vue&type=style&index=1&id=211b32be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211b32be",
  null
  
)

export default component.exports